import React, { useContext, useEffect, useState } from 'react'
import { CauseCodeTreeData } from 'card-data/MultiCauseCode'
import { connect } from 'react-redux'
import { getApiTargetInfo, getUnitTypeCode } from 'core/selectors'
import { Title, Content, FullHeightSizer } from 'core/screen-util'
import { Select } from 'antd'
import SpinContext from 'context/SpinContext'
import { ErrorContext } from 'context'
import { getCauseCodeAll } from 'api/pgads'
const CauseCodeLookup = ({ unitTypeCode, apiTargetInfo }) => {
  const [selCauseCode, setSelCauseCode] = useState('All')
  const [causeCodeList, setCauseCodeList] = useState([])
  const { setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  useEffect(
    _ => {
      setSpinning(true)
      getCauseCodeAll(apiTargetInfo).fork(setError, list => {
        setSpinning(false)
        setCauseCodeList(list)
      })
    },
    [apiTargetInfo, setError, setSpinning]
  )
  return (
    <FullHeightSizer heightOffset={150}>
      {({ height }) => (
        <Content style={{ height: height - 50 }}>
          <div style={{ display: 'flex', marginBottom: '15px' }}>
            <Title style={{ 'min-width': '200px' }}>Cause Code Look Up</Title>
            <Select
              showSearch
              mode="multiple"
              value={selCauseCode}
              onChange={e => setSelCauseCode(e)}
              style={{ width: '100%' }}
              placeholder="Select Unit Type"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              <Select.Option value="All">All</Select.Option>
              {Object.keys(unitTypeCode).map(e => (
                <Select.Option key={e} value={e}>
                  {unitTypeCode[e]}
                </Select.Option>
              ))}
            </Select>
          </div>

          <CauseCodeTreeData
            height={height - 150}
            width={500}
            unitCodes={
              selCauseCode.includes('All') || selCauseCode.length === 0
                ? Object.keys(unitTypeCode)
                : selCauseCode
            }
            causeCodeList={causeCodeList}
            // unitCodes={['CC']}
          />
        </Content>
      )}
    </FullHeightSizer>
  )
}

const mapStateToProps = state => ({
  unitTypeCode: getUnitTypeCode(state),
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(CauseCodeLookup)
